import { render, staticRenderFns } from "./TreeNodeDialog.vue?vue&type=template&id=2bce8fad&scoped=true&"
import script from "./TreeNodeDialog.vue?vue&type=script&lang=js&"
export * from "./TreeNodeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce8fad",
  null
  
)

export default component.exports